<!-- SOLO MOBILE -->
<div class="lg:hidden">
    <!-- Sidebar fijo -->
    <aside class="mobile-sidebar" [class.open]="mobileSidebar.open()">
    <p-menu [model]="items" class="w-full">
            <!-- Header con logo/título -->
            <ng-template #start>
                <div class="menu-header">
                    <img [src]="logoSrc" alt="Logo" width="28" height="28" class="" />
                    <div class="brand-title">
                        {{ sdSubtitle }}<br />
                        {{ sdPais }}
                    </div>
                </div>
            </ng-template>

            <!-- Encabezado de submenú -->
            <ng-template #submenuheader let-item>
                <span class="section-title">{{ item.label }}</span>
            </ng-template>

            <!-- Ítem -->
            <ng-template #item let-item>
                <a
                    pRipple
                    class="flex items-center p-menu-item-link"
                    (click)="onItemClick($event, item)"
                    [routerLink]="$any(item).routerLink || null"
                    [queryParams]="$any(item).queryParams || null"
                    [fragment]="$any(item).fragment || null"
                    [attr.aria-disabled]="$any(item).disabled ? true : null"
                >
                    <span [class]="$any(item).icon"></span>
                    <span class="ml-2">{{ item.label }}</span>
                </a>
            </ng-template>

            <!-- Footer usuario -->
            <ng-template #end>
                <button pRipple class="user-footer">
                    @if (resolvedAvatarUrl) {
                        <p-avatar [image]="resolvedAvatarUrl" class="mr-2" shape="circle"></p-avatar>
                    } @else {
                        <p-avatar class="mr-2" shape="circle">
                            <ng-template pTemplate="content">
                                <span class="avatar-fallback">{{ initials }}</span>
                            </ng-template>
                        </p-avatar>
                    }

                    <span class="inline-flex flex-col text-left">
                        <span class="font-bold">{{ displayFormattedName }}</span>
                        <span class="text-sm">Admin</span>
                    </span>
                </button>
            </ng-template>
        </p-menu>
    </aside>

    <!-- Máscara permanente, activada por clase (sin *ngIf) -->
    <div class="mobile-mask" [class.open]="mobileSidebar.open()" (click)="close()"></div>
</div>
